// extracted by mini-css-extract-plugin
module.exports = {"inputLabel":"style__inputLabel__zfYdU","inputError":"style__inputError__GUOKV","matchTable":"style__matchTable__j6kP+"};